import { render, staticRenderFns } from "./TagFlowGrid.vue?vue&type=template&id=4c49be7c&scoped=true&"
import script from "./TagFlowGrid.vue?vue&type=script&lang=js&"
export * from "./TagFlowGrid.vue?vue&type=script&lang=js&"
import style0 from "./TagFlowGrid.vue?vue&type=style&index=0&id=4c49be7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c49be7c",
  null
  
)

export default component.exports